import { ChatSetting } from '../../../../../../../Model/Coach';

const texts = {
  chat: 'Chat Settings',
  chatDescription: 'Customize your chat functionality',
  chatSetting: {
    [ChatSetting.ENABLE_WORKOUT_NOTIFICATIONS]: 'Cloudbot Workout notifications',
    [ChatSetting.ENABLE_SUMMARY_NOTIFICATIONS]: 'Cloudbot Summary notifications',
    [ChatSetting.ENABLE_FEEDBACK_NOTIFICATIONS]: 'Cloudbot Feedback notifications',
  },
  enabled: 'Enabled',
  disabled: 'Disabled',
  chatSettingSaveSuccessful: 'Successfully saved the chat settings',
  chatSettingSaveFailed: 'Error changing the chatbot settings',
  emojiSkinTone: 'Emoji Skin Tone',
  emojiSkinToneDescription: 'Select the default skin tone for emojis in chat messages',
  emojiSkinToneSaveSuccessful: 'Successfully saved emoji skin tone preference',
  emojiSkinToneSaveFailed: 'Error saving emoji skin tone preference',
  skinToneOptions: {
    default: 'Default',
    light: 'Light',
    mediumLight: 'Medium-Light',
    medium: 'Medium',
    mediumDark: 'Medium-Dark',
    dark: 'Dark',
  },
};

export default texts;
